module.exports = __webpack_public_path__ + "static/defender-90-300tdi-restored-8290a251321585322a4762aa83b206db.jpg";